(function () {
  'use strict';

  // Guard against running twice -- every jack-* section includes this script
  // tag so each section works standalone even if others are removed, but we
  // only want init() to actually run once per page load.
  if (window.__jackPortfolioInit) return;
  window.__jackPortfolioInit = true;

  // ---- Fade-in on scroll (matches original FadeIn component) ----
  function initFadeIns() {
    var els = document.querySelectorAll('[data-fade]');
    if (!els.length) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseFloat(el.dataset.delay || '0');
            var duration = parseFloat(el.dataset.duration || '0.7');
            el.style.transitionProperty = 'opacity, transform';
            el.style.transitionDuration = duration + 's';
            el.style.transitionDelay = delay + 's';
            el.style.transitionTimingFunction = 'cubic-bezier(0.25, 0.1, 0.25, 1)';
            requestAnimationFrame(function () {
              el.style.opacity = '1';
              el.style.transform = 'translate(0, 0)';
            });
            io.unobserve(el);
          }
        });
      },
      { threshold: 0, rootMargin: '50px' }
    );
    els.forEach(function (el) {
      var x = getComputedStyle(el).getPropertyValue('--fade-x') || '0px';
      var y = getComputedStyle(el).getPropertyValue('--fade-y') || '30px';
      el.style.opacity = '0';
      el.style.transform = 'translate(' + x.trim() + ', ' + y.trim() + ')';
      io.observe(el);
    });
  }

  // ---- Magnet: mouse-following hover effect (matches original Magnet component) ----
  function initMagnets() {
    var magnets = document.querySelectorAll('[data-magnet]');
    if (!magnets.length) return;
    magnets.forEach(function (el) {
      var padding = parseFloat(el.dataset.padding || '100');
      var strength = parseFloat(el.dataset.strength || '3');
      var active = false;
      el.style.willChange = 'transform';
      function onMove(e) {
        var rect = el.getBoundingClientRect();
        var cx = rect.left + rect.width / 2;
        var cy = rect.top + rect.height / 2;
        var within =
          e.clientX > rect.left - padding &&
          e.clientX < rect.right + padding &&
          e.clientY > rect.top - padding &&
          e.clientY < rect.bottom + padding;
        if (within) {
          active = true;
          var tx = (e.clientX - cx) / strength;
          var ty = (e.clientY - cy) / strength;
          el.style.transition = 'transform 0.3s ease-out';
          el.style.transform = 'translate3d(' + tx + 'px, ' + ty + 'px, 0)';
        } else if (active) {
          active = false;
          el.style.transition = 'transform 0.6s ease-in-out';
          el.style.transform = 'translate3d(0, 0, 0)';
        }
      }
      window.addEventListener('mousemove', onMove, { passive: true });
    });
  }

  // ---- Marquee: dual-row scroll-driven horizontal scroll ----
  // Only listens to scroll while the marquee section is actually near the
  // viewport -- avoids doing work on every scroll event for the whole page.
  function initMarquee() {
    var section = document.querySelector('[data-marquee-section]');
    if (!section) return;
    var row1 = section.querySelector('[data-marquee-row="1"]');
    var row2 = section.querySelector('[data-marquee-row="2"]');
    var ticking = false;
    function update() {
      var rect = section.getBoundingClientRect();
      var sectionTop = rect.top + window.scrollY;
      var offset = (window.scrollY - sectionTop + window.innerHeight) * 0.3;
      if (row1) row1.style.transform = 'translateX(' + (offset - 200) + 'px)';
      if (row2) row2.style.transform = 'translateX(' + -(offset - 200) + 'px)';
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    var active = false;
    function activate() {
      if (active) return;
      active = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }
    function deactivate() {
      if (!active) return;
      active = false;
      window.removeEventListener('scroll', onScroll);
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) activate();
          else deactivate();
        });
      },
      { rootMargin: '200px 0px' }
    );
    io.observe(section);
  }

  // ---- AnimatedText: per-character scroll-linked opacity reveal ----
  // Scroll listener only runs while the element is near the viewport, and is
  // removed entirely once the reveal finishes (progress reaches 1) -- no
  // need to keep recomputing every character's opacity forever after that.
  function initAnimatedText() {
    var els = document.querySelectorAll('[data-animated-text]');
    if (!els.length) return;
    els.forEach(function (el) {
      var text = el.textContent;
      el.textContent = '';
      var spans = [];
      for (var i = 0; i < text.length; i++) {
        var ch = text[i];
        var display = ch === ' ' ? ' ' : ch;
        var wrapper = document.createElement('span');
        wrapper.style.position = 'relative';
        wrapper.style.display = 'inline-block';
        var hidden = document.createElement('span');
        hidden.style.visibility = 'hidden';
        hidden.textContent = display;
        var visible = document.createElement('span');
        visible.style.position = 'absolute';
        visible.style.left = '0';
        visible.style.top = '0';
        visible.style.opacity = '0.2';
        visible.textContent = display;
        wrapper.appendChild(hidden);
        wrapper.appendChild(visible);
        el.appendChild(wrapper);
        spans.push(visible);
      }
      var ticking = false;
      var done = false;
      var io;
      function update() {
        var rect = el.getBoundingClientRect();
        var vh = window.innerHeight;
        var startY = vh * 0.8;
        var endY = vh * 0.2;
        var totalSpan = startY - endY + rect.height;
        var traveled = startY - rect.top;
        var progress = Math.min(1, Math.max(0, traveled / totalSpan));
        var n = spans.length;
        spans.forEach(function (s, idx) {
          var charStart = idx / n;
          var charEnd = charStart + 1 / n;
          var op;
          if (progress <= charStart) op = 0.2;
          else if (progress >= charEnd) op = 1;
          else op = 0.2 + ((progress - charStart) / (charEnd - charStart)) * 0.8;
          s.style.opacity = op;
        });
        ticking = false;
        if (progress >= 1) {
          done = true;
          deactivate();
          if (io) io.disconnect();
        }
      }
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }
      var active = false;
      function activate() {
        if (active || done) return;
        active = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        update();
      }
      function deactivate() {
        if (!active) return;
        active = false;
        window.removeEventListener('scroll', onScroll);
      }
      io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (done) return;
            if (entry.isIntersecting) activate();
            else deactivate();
          });
        },
        { rootMargin: '200px 0px' }
      );
      io.observe(el);
    });
  }

  // ---- Projects: sticky-stacking scale-down effect ----
  // Only listens to scroll while the projects section is near the viewport.
  function initProjectCards() {
    var cards = document.querySelectorAll('[data-project-card]');
    if (!cards.length) return;
    var section = document.getElementById('projects') || cards[0].parentElement;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      cards.forEach(function (card) {
        var shrink = parseFloat(card.dataset.scaleTarget || '0');
        var rect = card.getBoundingClientRect();
        var progress = 1 - Math.min(1, Math.max(0, rect.top / vh));
        var scale = 1 - shrink * progress;
        var inner = card.querySelector('[data-project-card-inner]');
        if (inner) inner.style.transform = 'scale(' + scale + ')';
      });
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    var active = false;
    function activate() {
      if (active) return;
      active = true;
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }
    function deactivate() {
      if (!active) return;
      active = false;
      window.removeEventListener('scroll', onScroll);
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) activate();
          else deactivate();
        });
      },
      { rootMargin: '300px 0px' }
    );
    io.observe(section);
  }

  function init() {
    initFadeIns();
    initMagnets();
    initMarquee();
    initAnimatedText();
    initProjectCards();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
